import React, { useId, useRef } from 'react';
import { insertTemplateVariable, nextVariable } from '../utils/templateVariable';

export default function VariableTextField({ label, value, onChange, multiline = false, rows = 4, maxLength, required, placeholder, style = 'numbered', maxVariables = Infinity, hint, showCount = false, url = false }) {
  const field = useRef(null);
  const inputId = useId();
  const next = nextVariable(value, style, maxVariables);

  function insert() {
    const input = field.current;
    if (!input) return;
    const result = insertTemplateVariable(value, input.selectionStart, input.selectionEnd, { style, maxVariables, url });
    if (!result || (maxLength && result.text.length > maxLength)) return;
    onChange(result.text);
    requestAnimationFrame(() => {
      input.focus();
      input.setSelectionRange(result.caret, result.caret);
    });
  }

  const props = { id: inputId, ref: field, className: multiline ? 'textarea' : 'input', value, onChange: event => onChange(event.target.value), maxLength, required, placeholder };
  return <div className="form-group template-variable-field">
    <div className="template-variable-heading">
      <label className="label" htmlFor={inputId}>{label}</label>
      <button type="button" className="btn btn-ghost btn-sm" disabled={!next || Boolean(maxLength && value.length + next.length > maxLength)}
        onMouseDown={event => event.preventDefault()} onClick={insert} aria-label={`Insert variable ${next || ''} into ${label}`}>
        + Insert variable {next}
      </button>
    </div>
    {multiline ? <textarea {...props} rows={rows} /> : <input {...props} />}
    {(hint || showCount) && <div className="template-variable-meta">
      {hint && <span>{hint}</span>}{showCount && <span>{value.length}/{maxLength}</span>}
    </div>}
  </div>;
}
